{
	"$schema": "https://schemas.wp.org/trunk/block.json",
	"apiVersion": 3,
	"__experimental": true,
	"name": "core/playlist-track",
	"title": "Playlist track",
	"category": "media",
	"parent": [ "core/playlist" ],
	"description": "Playlist track.",
	"keywords": [ "music", "sound" ],
	"textdomain": "default",
	"usesContext": [ "showArtists", "currentTrack" ],
	"attributes": {
		"blob": {
			"type": "string",
			"role": "local"
		},
		"id": {
			"type": "number"
		},
		"uniqueId": {
			"type": "string"
		},
		"src": {
			"type": "string"
		},
		"type": {
			"type": "string",
			"default": "audio"
		},
		"album": {
			"type": "string"
		},
		"artist": {
			"type": "string"
		},
		"image": {
			"type": "string"
		},
		"length": {
			"type": "string"
		},
		"title": {
			"type": "string"
		}
	},
	"supports": {
		"html": false,
		"interactivity": {
			"clientNavigation": true
		},
		"reusable": false
	},
	"style": "wp-block-playlist-track"
}
